import all from "../assets/images/logo.png";
import back from "../assets/icons/back.png";
import cardio from "../assets/icons/cardio.png";
import chest from "../assets/icons/chest.png";
import arms from "../assets/icons/arms.png";
import neck from "../assets/icons/neck.png";
import shoulders from "../assets/icons/shoulder.png";
import legs from "../assets/icons/legs.png";
import waist from "../assets/icons/waist.png";

export const bodyPartIcons = [
  {
    name: "all",
    icon: all,
  },
  {
    name: "back",
    icon: back,
  },
  {
    name: "cardio",
    icon: cardio,
  },
  {
    name: "chest",
    icon: chest,
  },
  {
    name: "upper arms",
    icon: arms,
  },
  {
    name: "lower arms",
    icon: arms,
  },
  {
    name: "neck",
    icon: neck,
  },
  {
    name: "shoulders",
    icon: shoulders,
  },
  {
    name: "upper legs",
    icon: legs,
  },
  {
    name: "lower legs",
    icon: legs,
  },
  {
    name: "waist",
    icon: waist,
  },
];
